module.exports = __webpack_public_path__ + "img/ce6.80e75d80.png";